<template>
<b-container fluid>
    <div class="body-wrapper">
        <div class="body-title">
            <h5 style="color:#2284ab">Exemption Application - Guard Mapping</h5>
        </div>
        <b-alert :show = "showDismissibleAlert" dismissible 
            @dismissed="showDismissibleAlert=false"
            
            :variant="variant">
            {{alertText}}
        </b-alert>
        <div class="body-content">
            <b-card no-body>
                <b-row>
                    
                  <b-col md="6">
                       
                      <b-input-group prepend="Map Guard" size="sm">
                        <b-input-group-prepend>
                        <b-form-select v-model="SearchType" size="sm" >
                            <option value="1">Search Guard by Registration No.</option>
                            <option value="2">Search Guard by Name</option>
                        </b-form-select>
                        </b-input-group-prepend>
                        <b-form-input v-model="SearchWord"></b-form-input>

                        <b-input-group-append>
                            <b-btn variant="secondary" @click="Search">Search</b-btn>
                        </b-input-group-append>

                        </b-input-group>
                  </b-col>
                  <b-col >
                    <!-- <b-btn class="float-right" variant="info" size="sm" @click="addNewGuard">Register New Guard</b-btn> -->
                  </b-col>
                </b-row>
                <hr/>
                <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;"  class="mt-2">
                <p style="font-size: 17px;color:#2284ab;">Guards List</p>
                <b-row align-h="center">
                    <b-col>
                      <b-row class="mb-2">
                          <b-col md="4" >
                              <b-input-group>
                                  <b-form-input v-model="filter" placeholder="Type to Search" size="sm" />
                                  <b-input-group-append>
                                  <b-btn :disabled="!filter" @click="filter = ''"  size="sm">Clear</b-btn>
                                  </b-input-group-append>
                              </b-input-group>
                              
                          </b-col>
                          <b-col></b-col>
                          <b-col md="4" >
                              <b-form-group horizontal label="Sort" class="mb-0" label-size="sm" label-cols="2">
                              <b-input-group>
                                  <b-form-select v-model="sortBy" :options="sortOptions"  size="sm">
                                  <option slot="first" :value="null">-- none --</option>
                                  </b-form-select>
                                  <b-input-group-append>
                                  <b-form-select :disabled="!sortBy" v-model="sortDesc"  size="sm">
                                      <option :value="false">Asc</option>
                                      <option :value="true">Desc</option>
                                  </b-form-select>
                                  </b-input-group-append>
                              </b-input-group>
                              </b-form-group>
                          </b-col>
                      
                      </b-row>
                      <b-table show-empty head-variant="dark"
                                  stacked="md"
                                  bordered
                                  striped
                                  :items="employers"
                                  :fields="fields"
                                  :current-page="currentPage"
                                  :per-page="perPage"
                                  :filter="filter"
                                  :sort-by.sync="sortBy"
                                  :sort-desc.sync="sortDesc"
                                  style="font-size:12px"   
                      >
  
                          <template slot="actions" slot-scope="row">
                              <b-button variant="link" size="sm" @click.stop="viewGuard(row.item, row.index, $event.target)" 
                                  class="mr-1 pt-0 pb-0" v-b-tooltip.hover title="View Guard Details"  v-if="!LockProfile">
                                  <i class="fa fa-eye" style="font-size:16px;color:green"></i>
                              </b-button>
                              <b-button size="sm" @click.stop="editMember(row.item, row.index, $event.target)" 
                                  class="mr-1 pt-0 pb-0"  variant="link" v-b-tooltip.hover title="Edit Guard Details"  v-if="!LockProfile">
                                  <i class="fa fa-edit" style="font-size:16px;color:blue"></i>
                              </b-button>
                              <b-button size="sm" @click.stop="deleteMember(row.item, row.index, $event.target)" 
                                  class="mr-1 pt-0 pb-0"  variant="link" v-b-tooltip.hover title="Delete Guard Mapping"  v-if="!LockProfile">
                                  <i class="fa fa-trash" style="font-size:16px;color:red"></i>
                              </b-button>
                              
                          </template>
                      </b-table>
                      <b-row>
                        <b-col md="8" class="my-1">
                            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0"  size="sm"/>
                        </b-col>
                        <b-col md="4" class="my-1">
                            <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
                            <b-form-select :options="pageOptions" v-model="perPage"  size="sm" />
                            </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col class="float-right"><b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button></b-col>
                </b-row>
            </div>
            <b-modal id="modalSearch" title="Search Guard" size="lg">
              <pre> 
                <b-table show-empty head-variant="dark"
                    stacked="md"
                    bordered
                    striped
                    :items="searchList"
                    :fields="searchFields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    style="font-size:12px"   
                >
    
                  <template slot="actions" slot-scope="row">
                      <b-button size="sm" @click.stop="selectMember(row.item, row.index, $event.target)" 
                          class="mr-1 pt-0 pb-0" variant="outline-danger" v-b-tooltip.hover title="Delete Member"  v-if="!LockProfile">
                          Select
                      </b-button>
                  </template>
                  <template slot="row-details" slot-scope="row">
                      <b-card>
                          <span>{{row.item.description}}</span>
                      </b-card>
                  </template>
                </b-table>
              </pre>
            </b-modal>
            <b-modal id="modalConfirm" title="Are you sure?" size="sm">
              <pre>{{ modalInfo }}</pre>
              <div slot="modal-footer">
                  <b-button variant="danger" @click="modalConfirm" style= "margin-left:5px">Delete</b-button>
                  <b-button variant="info" @click="modalCancel" style= "margin-left:5px">Cancel</b-button>
              </div>
            </b-modal>

            </b-card>
            <b-modal id="modalNewGuard" title="Add New Guard" size="lg" @show="resetChild"  @hidden="reload" ok-only  ok-title="Close" ok-size="sm" ok-variant="secondary">
              <RegisterOnbehalfApp entityType="12" :form_data="form_data" :entityId="selectedId" :reset="resetFlag"></RegisterOnbehalfApp>
            </b-modal>
            <b-modal id="modalViewGuard" title="View Guard Details" size="lg" cancel-disabled>
              <GuardProfile :GuardID="selectedId"></GuardProfile>
            </b-modal>
        </div>
    </div>
</b-container>
</template>

<script>
import apis from "@/apis";
import RegisterOnbehalfApp from "@/components/OtherRegistrations/RegisterOnbehalfApp";
import GuardProfile from "@/components/OtherRegistrations/GuardProfile";
export default {
  props: ["ExemptionApplicationId"],
  components: { RegisterOnbehalfApp, GuardProfile },
  computed: {
    getRegTyp() {
      let x = this.$store.getters.getRegTyp;
      //console.log(x);
      return x;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return { text: f.label, value: f.key };
      });
    }
  },
  data() {
    return {
      resetFlag: true,
      LockProfile: false,
      saved: false,
      form: {
        AgencyID: "00000000-0000-0000-0000-000000000000",
        GuardID: "00000000-0000-0000-0000-000000000000",
        EmployerID: "00000000-0000-0000-0000-000000000000",
        IsActive: true
      },
      SearchWord: "",
      SearchType: "1",
      employers: [],
      searchList: [],
      searchFields: [
        { key: "EmployerName", label: "Guard Name", sortable: true },
        { key: "RegistrationNumber", label: "Registration No", sortable: true },
        { key: "actions", label: "-" }
      ],
      fields: [
        { key: "EntityName", label: "Guard Name", sortable: true },
        { key: "RegistrationNumber", label: "Registration No", sortable: true },
        { key: "EmployerName", label: "Employer Name", sortable: true },
        { key: "actions", label: "-" }
      ],
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedId: "00000000-0000-0000-0000-000000000000",
      saved: false
    };
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    reload(evt) {
      this.resetFlag = false;
      this.getAgencyMapping(12);
    },
    resetChild(evt) {
      if(this.selectedId=="00000000-0000-0000-0000-000000000000")
      {
        this.resetFlag = true;
      }
      else{
        this.resetFlag = false;
      }
    },
    onClickButton() {
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    Search() {
      this.showDismissibleAlert = false;

      if (this.SearchWord == "") {
        this.alertText = "Please enter the search criteria";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        return;
      } else if (
        this.SearchType == 1 &&
        !Number.isInteger(parseInt(this.SearchWord))
      ) {
        this.alertText = "Please enter Numeric value";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        return;
      }
      var promise = apis.searchGuard(this.SearchWord, this.SearchType);

      promise
        .then(response => {
          if (response.status == 200) {
            this.searchList = response.body;
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });

      this.$root.$emit("bv::show::modal", "modalSearch");
    },

    getAgencyMapping(RegType) {
      var userinfo = this.$store.getters.loggedUser;
    //   alert(this.ExemptionApplicationId);
      let promise = apis.getExemptionApplicationGuardMapping(this.ExemptionApplicationId, userinfo.UserId);

      promise
        .then(response => {
          if (response.status == 200) {
            this.employers = response.body;
            this.totalRows = this.employers.length;
            if (this.employers.length > 0) {
              this.saved = true;
            } else {
              this.saved = false;
            }
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    //Add Mapping
    selectMember(item, index, target) {
      var userinfo = this.$store.getters.loggedUser;
      this.form.GuardID = item.EmployerID;
      this.form.AgencyID = userinfo.UserId;
      this.form.IsActive = true;
      //alert(this.form);
      let promise = apis.updateAgencyGuardMapping(this.form);

      promise
        .then(response => {
          //console.log("Response", response.body);
          if (response.status == 200) {
            this.alertText = "Record Added Successfully.";
            this.getAgencyMapping(12);
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalSearch");
    },

    //Add New Guard
    addNewGuard() {
      this.selectedId = "00000000-0000-0000-0000-000000000000";
      this.$root.$emit("bv::show::modal", "modalNewGuard");
    },

    //View New Guard
    viewGuard(item, index, button) {
      this.selectedId = item.ExemptionGuardID ;
      this.$root.$emit("bv::show::modal", "modalViewGuard");
    },

    //Edit Member
    editMember(item, index, button) {
      this.selectedId = item.ExemptionGuardID;
      this.form_data=item;
      // console.log(item);
      this.$root.$emit("bv::show::modal", "modalNewGuard");
    },

    //Delte Mapping post confirmation
    deleteMember(item, index, button) {
      this.form.AgencyID = item.AgencyID;
      this.form.GuardID = item.GuardID;
      this.form.IsActive = false;
      let info = "You want to delete record for:" + "\n" + item.GuardName;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    modalCancel() {
      this.onReset();
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      let promise = apis.updateAgencyGuardMapping(this.form);

      promise
        .then(response => {
          if (response.status == 200 && response.body == "1") {
            this.alertText = "Record removed Successfully.";
            this.getAgencyMapping(11);
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    }
  },
  mounted() {
    //   alert(1);
    //   alert(this.ExemptionApplicationId);
    //   alert(1);
    this.getAgencyMapping(12);
  }
};
</script>

<style scoped>
.body-wrapper {
  margin-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  border: solid thin #ccc;
  -webkit-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
  box-shadow: -7px 10px 14px -8px rgba(0, 0, 0, 0.32);
}

.body-title {
  padding: 15px 25px;
  background: #fcfcfc;
  border-bottom: solid 2px #aaa;
}

.body-content {
  padding: 25px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/AgencyExemption/ExemptionApplicationGuardMap.vue